<template>
  <component :is="tag" class="fts-badge" :class="computedClass">
    <fts-tippy
      :tag="tag"
      :trigger-tag="tag"
      append-trigger-class="badge-wrapper"
      :content="tooltip"
      class="badge-tippy"
      v-if="!!tooltip"
    >
      <component :is="tag" class="badge-content">
        <slot />
      </component>
    </fts-tippy>

    <component :is="tag" class="badge-wrapper" v-else>
      <component :is="tag" class="badge-content">
        <slot />
      </component>
    </component>
  </component>
</template>

<script>
import FTSTippy from './FTSTippy';

export default {
  components: {
    'fts-tippy': FTSTippy
  },
  props: {
    tag: {
      type: String,
      default: "span"
    },
    color: {
      type: String,
      default: "default"
    },
    variant: {
      type: String,
      validator: value => ["pill"].indexOf(value) > -1
    },
    size: {
      type: String,
      validator: value => ["sm", "md"].indexOf(value) > -1
    },
    tooltip: [String, Number, Boolean],
    hoverable: Boolean,
    wrap: Boolean
  },
  computed: {
    computedClass() {
      let classes = "badge-default";

      if (!!this.color) {
        const color = [
          'primary', 
          'secondary', 
          'success', 
          'danger', 
          'warning', 
          'dark', 
          'ternary-green', 
          'ternary-blue', 
          'ai',
          'text', 
          'default'
        ].find(x => x == this.color.toLowerCase());

        if (color) {
          classes = `badge-${color}`;
        }
      }

      if (!!this.variant) {
        classes += ` badge-${this.variant.toLowerCase()}`;
      }

      if (!!this.size) {
        classes += ` badge-${this.size.toLowerCase()}`;
      } else {
        classes += " badge-md";
      }

      if (this.hoverable) {
        classes += " badge-hover";
      }

      if (this.wrap) {
        classes += " badge-wrap";
      }

      return classes;
    }

  }
}
</script>

<style lang="scss">
@mixin colors() {
  $colors:
    primary fts-primary-rgb 0.09, 
    secondary fts-secondary-rgb 0.09,
    success fts-success-rgb 0.1,
    danger fts-danger-rgb 0.09,
    warning fts-warning-rgb 0.1,
    dark fts-dark-rgb 0.09,
    ternary-green fts-ternary-green-rgb 0.125,
    ternary-blue fts-ternary-blue-rgb 0.125,
    ai fts-ai-rgb 0.125,
    text fts-text-rgb 0.09,
    default fts-default-rgb 0.125
  ;
  @each $name, $color, $opacity in $colors {
    &.badge-#{$name} {
      background-color: rgba(var(--#{$color}), $opacity);
      color: rgb(var(--#{$color}));
      &.badge-hover:hover {
        background-color: rgba(var(--#{$color}), $opacity * 1.5);
        cursor: pointer;
      }
    }
  }
}
.fts-badge {
  @include colors();
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: default;
  .badge-wrapper {
    max-width: 100%;
    display: inherit;
    padding: 0.188rem 0.375rem;
  }
  .badge-content {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .badge-tippy {
    max-width: 100%;
    display: inherit;
  }
  &.badge-pill {
    border-radius: 10em;
    .badge-wrapper {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
  &.badge-sm {
    font-size: 0.75rem;
  }
  &.badge-wrap {
    .badge-content {
      white-space: wrap;
    }
  }
}
</style>